export const APP_ROUTES = {
  HOME: { route: '/' },
  AI_SIGNUP: { route: '/ai-signup' },
  CASE_STUDIES: {
    route: '/case-studies/:caseStudy',
    routeCreator: (caseStudy: string) => `/case-studies/${caseStudy}`,
  },
} as const;
